<template>
	<div class="goods">
		<v-head :title="title"></v-head>
     <div class="detail">
        <h4>{{base.title}}</h4>
        <div class="date"><span>日期：{{base.createTime | limitDate}}</span>
          <span>发件人：{{base.sender}}</span></div>
     </div>
    <div class="content">{{base.content}}</div>
    <div class="EnclosureBox">
    <div class="Enclosure">
      点击相关附件可下载
    </div>
     <div class="EnclosureList">
       <div class="liBox" @click="downloadEnclosure">
        <van-icon name="down" />
        <p>{{fileData.fileName?fileData.fileName:'无附件'}}</p>
       </div>
     </div>
   </div>
	</div>
</template>
<script>
import {
    queryMail,
    delMessageReceiver,
    downLoadFile,
    saveReceiver,
    unRead,
    getCheckMessage,
    findInfoById,
    findFileById
} from "@/api/dictionary";
import { Field, Button,Toast,CellGroup,Dialog,Icon} from "vant";
import vHead from "../../components/Subhead.vue";
import { mapGetters, mapState, mapMutations } from "vuex";
import { getSessionStore } from "@/utils/sessionStorage";
export default {
  data() {
    return {
     title:"站内信",
     base: {
        enclosureId:'',
      },
      fileData:{
        fileName:'',
      }
    };
  },
  components: {
    vHead,
    [Button.name]: Button,
    [Toast.name]: Toast,
    [CellGroup.name]: CellGroup,
    [Dialog.name]: Dialog,
    [Icon.name]: Icon,
  },
    computed:{
        id(){
          return this.$route&&this.$route.query.infoId;
        }
    },
  methods: {
      detail(infoId) {
          findInfoById({"infoId":infoId})
              .then(res => {
                  if (res.success) {
                      this.base = res.result; 
                      this.findFileById();   
                  }
              })
              .catch(() => {
                  Toast.fail("获取数据失败");
              });
      },
      findFileById(){
        findFileById({"id":this.base.enclosureId})
              .then(res => {
                  if (res.success) {
                      this.fileData = res.result;    
                  }
              })
              .catch(() => {
                  Toast.fail("获取数据失败");
              });
      },
      
      downloadEnclosure(){
            if(!this.base.enclosureId){
                Toast.fail("该消息无附件");
                return;
            }
          window.open(downLoadFile(this.base.enclosureId));
      },
  },
mounted() {
  this.detail(this.id);
}
};
</script>

<style scoped>
body{ background:#fafafa; }
.detail h4{ font-size:16px; padding:20px 20px; text-align:left; line-height: 26px; }
.detail .date{ font-size:14px; margin-bottom: 15px; color: #888;padding:0 20px; text-align:center;}
.date span{ margin-right: 20px; }
.content{ font-size:14px;padding:0 20px;  line-height: 26px;
  }
.EnclosureBox{ padding: 0 20px; margin-top: 30px; border-top:#f3f3f3 solid 10px; padding-top: 25px; }
.Enclosure{ border-bottom: #ededed solid 1px; font-size:14px; padding-bottom: 20px; margin-bottom: 30px;}
.liBox{ font-size:14px; line-height: 15px; }
.liBox /deep/.van-icon{ width: 15px; height: 15px;  background:#378be1; display: block; float: left;
font-size:14px; color: #fff; margin-right: 5px;}
</style>